import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import TaskReferencesLayer from '../components/TaskReferencesLayer';

const TaskReferencesPage = () => (
  <MasterLayout pageTitle='Task Reference Tables'>
    <TaskReferencesLayer />
  </MasterLayout>
);

export default TaskReferencesPage;
